import { RootState } from '../../model/model'
import { createSelector } from '@reduxjs/toolkit'

const _selectFilters = (state: RootState) => state.reportFilters

export const selectFilters = createSelector(
	_selectFilters,
	reportFilters => reportFilters,
)
